import React, { useCallback, useEffect } from 'react';

import { IconButton, NotificationsNoneIcon } from '@gogame/components';
import { useSocket } from '@gogame/sockets';

import { EVENT_NEW_NOTIFICATION } from '../WebSocket';
import { Notifications } from './Notifications';
import { useLoadNotifications } from './data';
import { useSocketMarkAsRead, useSocketMarkAsReadAll } from './data/mutations';
import { useShowNewNotification } from './data/useShowNewNotification';
import { useSocketNewNotifications } from './data/useSocketNewNotifications';

export const NotificationsOpener = ({ openChildComponent, className }) => {
  const { data } = useLoadNotifications();
  const showToast = useShowNewNotification();

  const socket = useSocket();
  useSocketNewNotifications();
  const [socketMarkAsRead] = useSocketMarkAsRead();
  const [socketMarkAsReadAll] = useSocketMarkAsReadAll();

  const handleReadAllMessages = useCallback(async () => {
    await socketMarkAsReadAll({ all: true });
  }, [socketMarkAsReadAll]);

  const handleReadMessage = useCallback(
    async (notificationId) => {
      await socketMarkAsRead({ id: notificationId });
    },
    [socketMarkAsRead]
  );

  const handleOpenNotifications = useCallback(() => {
    openChildComponent(Notifications, {
      onReadMessage: handleReadMessage,
      onReadAllMessages: handleReadAllMessages,
    });
  }, [openChildComponent, data, handleReadMessage, Notifications]);

  useEffect(() => {
    const handleReceiveNewNotification = (message) => {
      showToast({
        onReadMessage: handleReadMessage,
        message,
      });
    };

    socket.on(EVENT_NEW_NOTIFICATION, handleReceiveNewNotification);
    return () => {
      socket.off(EVENT_NEW_NOTIFICATION, handleReceiveNewNotification);
    };
  }, [handleReadMessage, socket]);

  let badge = data?.unread;
  if (badge > 99) {
    badge = '99+';
  }
  return (
    <IconButton
      badge={badge}
      badgeColor={'error'}
      icon={<NotificationsNoneIcon />}
      tooltip={'Notifications'}
      tooltipPlacement={'right'}
      onClick={handleOpenNotifications}
      color={'inherit'}
      data-cy={'notifications'}
      className={className}
    />
  );
};
